/**
 * @file TeamTaskCards.jsx
 * @location src/components/team/TeamTaskCards.jsx
 * @role 모바일 카드 리스트 — TeamTaskTable 의 표를 ≤768px 에서 대체.
 *   TeamTaskRow 와 동일 표시 헬퍼(Chk·DueText·StatusTag) 재사용. cols 로 매니저/팀원 분기.
 */
import { useApp } from '../../store/AppContext';
import { useMembers } from '../../store/useMembers';
import { ackStatusMeta, STATUS, priorityMeta, isOverdue, isClosed } from '../../data/constants';
import { Chk, DueText, StatusTag } from '../ui/SharedUI';
import { Icon } from '../ui/Icon';
import { DEFAULT_COLS } from './TeamTaskRow';

const priTag = (p) => {
  if (!p || p === 'normal') return null;
  const m = priorityMeta(p);
  return <span className={`tag ${m.cls}`}>{m.label}</span>;
};

export function TeamTaskCards({ tasks, handleToggle, cols = DEFAULT_COLS }) {
  const { S, act } = useApp();
  const { mname } = useMembers();

  return (
    <div className="task-cards">
      {tasks.map((t) => {
        const sm = ackStatusMeta(t.status, t.acknowledgedAt);
        const od = isOverdue(t.due, t.status);
        const isOwner = t.aee === S.uid;
        const ownerChk = isOwner && t.status !== STATUS.CANCELLED
          ? <Chk done={t.status === STATUS.DONE} onClick={() => handleToggle(t)} />
          : null;
        const showLead = cols.includes('check') || cols.includes('status');
        return (
          <div key={t.id} className={`task-card${od ? ' card-overdue' : ''}`}>
            <div className="tc-lead">
              {showLead && (ownerChk ?? <StatusTag status={t.status} cls={sm.cls} label={sm.label} />)}
              <span
                className={`tc-title${isClosed(t.status) ? ' dn' : ''}`}
                onClick={() => act('SET_UI', { patch: { modalProg: true, progTargetId: t.id } })}
              >
                {t.templateId && <span className="kind-badge personal"><Icon name="reset" size={10} /></span>}
                {t.title}
              </span>
            </div>
            <div className="tc-meta">
              {cols.includes('aee') && <span className="member-chip"><span className="mc-name">{mname(t.aee)}</span></span>}
              {cols.includes('status') && <StatusTag status={t.status} cls={sm.cls} label={sm.label} />}
              {priTag(t.priority)}
              {cols.includes('due') && <DueText due={t.due} status={t.status} dateKind={t.dateKind} />}
            </div>
          </div>
        );
      })}
    </div>
  );
}
